import {Component, Input} from '@angular/core';
import {NgIf} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {IBroadcastNotification} from '../../interfaces/notifications/IBroadcastNotification';
import {BroadcastNotificationTypes} from '../../enum/BroadcastNotificationTypes';

@Component({
  selector: 'app-broadcast-notification-browser-preview',
  standalone: true,
  imports: [NgIf, MatIcon],
  templateUrl: './broadcast-notification-browser-preview.component.html',
  styleUrls: ['./broadcast-notification-browser-preview.component.css']
})
export class BroadcastNotificationBrowserPreviewComponent {
  @Input() notification: IBroadcastNotification | Partial<IBroadcastNotification> | null = null;

  BroadcastNotificationTypes = BroadcastNotificationTypes;
}
